import { Box, Skeleton } from '@mui/material';

interface TrendingSkeletonProps {
  count?: number;
}

const TrendingSkeleton = ({ count = 4 }: TrendingSkeletonProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mt: '45px',
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          width: '70%',
          height: 40,
          background: 'white',
          zIndex: 999,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Skeleton animation="wave" variant="circular" width={18} height={18} />
        <Skeleton animation="wave" height={18} width={180} />
      </Box>

      {[...Array(count)].map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: 1.5,
            pb: 2.5,
            borderBottom: index !== count - 1 ? '1px solid #e0e0e0' : 'none',
            alignItems: 'flex-start',
          }}
        >
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={110}
            height={90}
            sx={{ borderRadius: '4px', flexShrink: 0 }}
          />
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
           
            <Skeleton animation="wave" height={16} width="95%" />
            <Skeleton animation="wave" height={16} width="75%" />
            <Skeleton animation="wave" height={13} width={80} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TrendingSkeleton;